// extracted by css-extract-rspack-plugin
export default {"tableWrapper":"CseZ2l3jIDcVt66V"};